export default __webpack_public_path__ + "static/9-c12cb109ed69d5422abb905e99377410.jpg";